<template>
  <div class="liangxiang-assessment-report">
    <div class="title">
      <div class="school-name"> {{ reportData.schoolName }}学校学生OSA筛查表</div>
      <div class="title-actions">
        <div class="action-buttons">
          <button class="action-btn download-pdf no-print" @click="downloadPDF">下载PDF</button>
          <button class="action-btn download-pdf no-print" @click="printReport">打印</button>
        </div>
        <div class="sub-title">筛查日期：{{ reportData.gmtCreate ? reportData.gmtCreate.split(' ')[0] : '' }}</div>
      </div>
    </div>
    <div class="base-info">
      <div class="left">
        <div class="info-item">
          <span class="info-label">ID　　号：</span>
          <span class="info-value">{{ reportData.id }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">姓　　名：</span>
          <span class="info-value">{{ reportData.trueName }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">性　　别：</span>
          <span class="info-value">{{ reportData.sex === 1 ? '男' : '女' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">出生日期：</span>
          <span class="info-value">{{ reportData.birthday }}</span>
        </div>
      </div>
      <div class="right">
        <div class="info-item">
          <span class="info-label">PSQ评分：</span>
          <span class="info-value">{{ reportData.psqScore }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">OSA风险：</span>
          <span class="info-value">{{ reportData.osaResult }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">LSpO₂(%)：</span>
          <span class="info-value">{{ reportData.spo2min }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">ODI(次/h)：</span>
          <span class="info-value">{{ reportData.odi }}</span>
        </div>
      </div>
    </div>
    <table class="osa-table">
      <tr>
        <td class="section-title" rowspan="2">体征信息</td>
        <td>腺样体面容</td>
        <td>打鼾家族史</td>
        <td>身高（cm）</td>
        <td>体重（kg）</td>
        <td>BMI</td>
        <td>其他备注</td>
      </tr>
      <tr>
        <td>{{ reportData.adenoidFace }}</td>
        <td>{{ reportData.familyHistorySnore}}</td>
        <td>{{ reportData.height }}</td>
        <td>{{ reportData.weight }}</td>
        <td>{{ reportData.bmi }} {{ reportData.bmiStatus ? `（${reportData.bmiStatus}）` : '' }}</td>
        <td>{{ reportData.remarks }}</td>
      </tr>
      <tr>
        <td class="section-title" rowspan="2">OSA症状</td>
        <td>是否打鼾及每周次数</td>
        <td>是否张口呼吸</td>
        <td>白天上课嗜睡</td>
        <td>学习成绩下降</td>
        <td>注意缺陷/多动</td>
        <td>焦虑/抑郁</td>
      </tr>
      <tr>
        <td>{{ reportData.snoreFrequency }}</td>
        <td>{{ reportData.mouthBreathing }}</td>
        <td>{{ reportData.daytimeSleepiness }}</td>
        <td>{{ reportData.academicDecline}}</td>
        <td>{{ reportData.attentionDeficit}}</td>
        <td>{{ reportData.anxietyDepression }}</td>
      </tr>
      <tr>
        <td class="section-title" rowspan="2">OSA评估</td>
        <td>PSQ评分</td>
        <td>OSA-18评分</td>
        <td>MSpO₂(%)</td>
        <td>LSpO₂(%)</td>
        <td>ODI(次/h)</td>
        <td>睡眠效率</td>
      </tr>
      <tr>
        <td>{{ reportData.psqScore }}</td>
        <td>{{ reportData.osaScore }}</td>
        <td>{{ reportData.spo2avg }}</td>
        <td>{{ reportData.spo2min }}</td>
        <td>{{ reportData.odi }}</td>
        <td>{{ reportData.sleepEfficiency }}</td>
      </tr>
      <tr>
        <td class="section-title">健康建议</td>
        <td colspan="6">
          <div class="health-advice-content" v-html="reportData.healthAdvice"></div>
        </td>
      </tr>
    </table>
    <!-- <div class="footer">
      <div class="footer-left"></div>
      <div class="footer-right">
        <div>审核签名：{{ reportData.trueName }}</div>
        <div>时间：{{ reportData.gmtCreate ? reportData.gmtCreate.split(' ')[0] : '' }}</div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { downloadExportFile } from "@js/report-export-tool.js";
export default {
  name: 'LiangxiangAssessmentReport',
  data() {
    return {
      reportData: {}
    }
  },
  methods: {
    async fetchReportDetail(uid) {
      const res = await this.$api.getLiangXiangPageAssessmentDetail({ uid });
      console.log(res)
      if (res) {
        this.reportData = res;
      }
    },
    async downloadPDF() {
      console.log('下载PDF');
      try {
        const params = {
          uid: this.reportData.uid,
        };
        const response = await this.$api.downloadLiangXiangAssessmentPdf(params)
        console.log(response)
        window.open(response)
        
      } catch (error) {

      }
    },
    printReport() {
      window.print();
    }
  },
  mounted() {
    const uid = this.$router.history.current.query.uid;
    this.fetchReportDetail(uid);
  }
}
</script>

<style lang="scss" scoped>
@media print {

  .no-print {
    background-color: white !important;
  }
}
.liangxiang-assessment-report {
  padding: 24px;
  background: #fff;
  font-size: 14px;
  min-width: 800px;
  box-sizing: border-box;
  position: relative;

  .title {
    text-align: center;
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 20px;
    position: relative;

    .school-name {
      display: inline-block;
      position: relative;

      .underline {
        display: inline-block;
        position: relative;

        &::after {
          content: '';
          font-size: 12px;
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 100%;
          height: 1px;
          background-color: #000;
        }
      }
    }

    .title-actions {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;

      .action-buttons {
        display: flex;
        gap: 10px;
      }

      .action-btn {
        padding: 6px 12px;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        font-size: 14px;
        transition: background-color 0.3s;

        &.export-excel {
          background-color: #325FAC;
          color: white;

          &:hover {
            background-color: #325FAC;
          }

          // @media print {
          //   display: none;
          // }
        }

        &.download-pdf {
          background-color: #325FAC;
          color: white;

          &:hover {
            background-color: #325FAC;
          }

          // @media print {
          //   display: none;
          // }
        }
      }

      .sub-title {
        font-size: 16px;
        font-weight: normal;
      }
    }

    &::after {
      content: '';
      display: block;
      width: 100%;
      height: 1px;
      background: #333;
      margin: 16px 0 0 0;
      opacity: 0.2;
    }

    .sub-title {
      font-size: 16px;
      font-weight: normal;
      margin-top: 8px;
      text-align: right;
    }
  }

  .base-info {
    display: flex;
    justify-content: space-between;
    margin: 24px 0 16px 0;

    .left,
    .right {
      display: flex;
      flex-direction: column;
      gap: 12px;
      font-size: 15px;
    }

    .right {
      align-items: flex-end;
    }

    .info-item {
      display: flex;

      .info-label {
        text-align: left;
        margin-bottom: 4px;
      }

      .info-value {
        min-width: 120px;
        border-bottom: 1px solid #999;
        padding-bottom: 2px;
        text-align: center;
      }
    }
  }

  .osa-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 16px;

    td {
      border: 1px solid #333;
      padding: 8px 4px;
      text-align: center;
      font-size: 14px;
      height: 40px;
      vertical-align: middle;
      /* 添加此行，使内容垂直居中 */
      background-color: #fff;
    }

    .section-title {
      font-weight: bold;
      // background-color: #f5f5f5;
      text-align: center;
    }

    tr:nth-child(even) {
      background-color: #fff;
      // background-color: #f9f9f9;
    }

    .health-advice-content {
      text-align: left;
      padding: 10px;
      min-height: 100px;

      :deep(p),
      :deep(div),
      :deep(span) {
        margin-bottom: 8px;
        line-height: 1.5;
      }

      :deep(ul),
      :deep(ol) {
        padding-left: 20px;
        margin-bottom: 8px;
      }
    }
  }

  .footer {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 32px;

    .footer-right {
      text-align: right;
      font-size: 14px;
      line-height: 2;
    }
  }

  .page-number {
    position: absolute;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #000;
    color: #fff;
    padding: 2px 10px;
    border-radius: 10px;
    font-size: 12px;
  }
}
</style>
